<template>
  <div class="follow-page">
    <div class="follow-box">
      <div class="row header-tab">
        <div class="goback" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span class="title">返回</span>
        </div>
        <div class="follow-tab">
          <span :class="[ind===0?'follow-title active':'follow-title']" @click="changeInd(0)">管理关注公司</span>
          <span :class="[ind===1?'follow-title active':'follow-title']" @click="changeInd(1)">管理关注产业</span>
          <span :class="[ind===2?'follow-title active':'follow-title']" @click="changeInd(2)">管理关注关键词</span>
          <span :class="[ind===3?'follow-title active':'follow-title']" @click="changeInd(3)">管理关注人物</span>
        </div>
        <div></div>
      </div>
     <FocusCompany v-if="ind===0"/>
     <FocusIndustry v-if="ind===1"/>
     <FocusKeywords v-if="ind===2"/>
     <FocusPerson v-if="ind===3"/>
    </div>
  </div>
</template>

<script>
import FocusCompany from '@/components/concern/FocusCompany';
import FocusIndustry from '@/components/concern/FocusIndustry';
import FocusKeywords from '@/components/concern/FocusKeywords';
import FocusPerson from '@/components/concern/FocusPerson';

export default {
  data() {
    return {
      ind: 0,
      searchText: undefined,
      placeholder: '添加关注公司'
    };
  },
  methods: {
    goBack() {
      if (this.ind === 1) {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'industry'
          }
        });
      } else if (this.ind === 2) {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'keywords'
          }
        });
      } else if (this.ind === 3) {
        this.$router.push({
          path: '/concern',
          query: {
            type: 'person'
          }
        });
      } else if (this.ind === 0) {
        this.$router.push({
          path: '/concern'
        });
      }
    },
    changeInd(ind) {
      this.ind = ind;
      if (this.ind === 1) {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'industry'
          }
        });
      } else if (this.ind === 2) {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'keywords'
          }
        });
      } else if (this.ind === 3) {
        this.$router.push({
          path: '/follow',
          query: {
            type: 'person'
          }
        });
      } else if (this.ind === 0) {
        this.$router.push({
          path: '/follow'
        });
      }
    }
  },
  components: {
    FocusCompany,
    FocusIndustry,
    FocusKeywords,
    FocusPerson
  },
  mounted() {
    if (this.$route.query.type === 'industry') {
      this.ind = 1;
    } else if (this.$route.query.type === 'keywords') {
      this.ind = 2;
    } else if (this.$route.query.type === 'person') {
      this.ind = 3;
    }
  }
};
</script>

<style lang="scss" scoped>
.follow-page {
  position: relative;
  background-color: #f7f8fc;
  padding-top: 16px;
  .go-back {
    position: fixed;
    left: 32px;
    top: 96px;
  }
  .follow-box {
    width: 1200px;
    background-color: #ffffff;
    margin: auto;
    .header-tab {
      justify-content: space-between;
      width: 100%;
      height: 48px;
      line-height: 48px;
      padding: 0 24px;
      background-color: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f2f3f7;
      .goback {
        width: 72px;
        height: 26px;
        border-radius: 2px;
        color: #464d6c;
        background-color: #ffffff;
        cursor: pointer;
        .title {
          color: #464d6c;
          font-size: 14px;
        }
        .el-icon-arrow-left {
          color: #747990;
          font-size: 14px;
        }
      }
      .follow-tab {
        margin-left: -41px;
      }
      .follow-title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #747990;
        padding-right: 32px;
        cursor: pointer;
        &:hover {
          color: #45a8cc;
        }
      }
      .active {
        color: #45a8cc;
      }
      .empty-div {
        width: 100px;
        height: 20px;
      }
    }
   
  }
}
</style>
